// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MeetingAttendee  {
    _originalTypeClassName = "Loom.BO.MeetingAttendee";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MeetingAttendee.translate = translateService;
}
this.Id = null;
this.IsTraveller = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsTraveller:any;
Meeting:any;
Attendee:any;
static setMeeting = ($this, value) => {
var oldValue = $this.Meeting;
$this.Meeting = value;
if (value != null) {
if (oldValue != null) {
Domain.Meeting.removeAttendees(oldValue, $this);
}
Domain.Meeting.addAttendees(value, $this);
}
}
static setAttendee = ($this, value) => {
var oldValue = $this.Attendee;
$this.Attendee = value;
if (value != null) {
}
}

static GetIsTraveller($this: any): any{if (CLMS.Framework.Number.LessThanOrEqual(() => $this.Meeting.Trips.length, () => 0)) {return false;}
return $this?.Meeting?.Trips?.linq?.any((a) => a?.Travellers?.linq?.any((t) => CLMS.Framework.Number.Equal(() => t.Employee.Id, () => $this.Attendee.Id)));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}